import { Injectable } from '@angular/core';
import { catchAndContinue, filterUndefined } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { PMOrderConstants } from 'src/app/models';
import { PMOrder, PMOrderType } from 'src/app/models/domain';
import { PMOrderDataService } from 'src/app/services';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';

@Injectable({ providedIn: 'root' })
export class PMOrderService {
  private readonly state = new CollectionState<PMOrder>(true);

  public readonly pmOrders$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public readonly primaryOrder$ = this.pmOrders$.pipe(
    map((orders) =>
      orders.find(
        (order) =>
          order.orderType &&
          PMOrderConstants.primaryOrderTypes.includes(order.orderType as PMOrderType)
      )
    )
  );

  public constructor(
    private readonly pmOrderDataService: PMOrderDataService,
    private readonly equipmentFacade: EquipmentFacadeService
  ) {}

  public loadByActiveEquipment(): Observable<void> {
    return this.equipmentFacade.selectedEquipmentId$.pipe(
      filterUndefined(() => {
        this.state.reset();
        this.state.setLoading(false);
      }),
      tap(() => {
        this.state.setLoading(true);
      }),
      switchMap((equipmentNumber) =>
        catchAndContinue(this.pmOrderDataService.getByEquipmentNumber(equipmentNumber), (error) => {
          this.state.setLoading(false);

          handleError(this.state, error);
        })
      ),
      tap((pmOrders) => {
        this.state.set(pmOrders);
      }),
      map(() => undefined)
    );
  }
}
